import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { id: "v1-mainContainer" }
const _hoisted_2 = { class: "site-mid" }
const _hoisted_3 = { class: "v1-login-page client-signup-page" }
const _hoisted_4 = { class: "v1-login-page-in" }
const _hoisted_5 = {
  class: "v1-loginForm",
  id: "loginForm"
}
const _hoisted_6 = { class: "overlay-container" }
const _hoisted_7 = { class: "overlay" }
const _hoisted_8 = { class: "overlay-panel overlay-left" }
const _hoisted_9 = { id: "signIn" }
const _hoisted_10 = { class: "form-container sign-in-container login" }
const _hoisted_11 = { class: "form-box" }
const _hoisted_12 = {
  key: 0,
  class: "error-message",
  style: {"color":"red","margin-bottom":"15px","text-align":"center"}
}
const _hoisted_13 = { class: "v1-input-field" }
const _hoisted_14 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_15 = { class: "v1-input-field" }
const _hoisted_16 = ["type"]
const _hoisted_17 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_18 = { class: "v1-input-field" }
const _hoisted_19 = { class: "custom-row" }
const _hoisted_20 = { class: "remmember-input" }
const _hoisted_21 = {
  for: "rememberMeCheckbox",
  class: "css-label"
}
const _hoisted_22 = {
  class: "forgot-text",
  href: "forgot-password.html"
}
const _hoisted_23 = { class: "input-submit signup-submit" }
const _hoisted_24 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginHeader = _resolveComponent("LoginHeader")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_LoginHeader),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h1", null, [
                    _createTextVNode(_toDisplayString(_ctx.constants.LOGIN_LEFT_TEXT) + " ", 1),
                    _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.constants.OUR_FAMILY_TEXT), 1)
                  ]),
                  _createElementVNode("button", _hoisted_9, _toDisplayString(_ctx.constants.LOGIN_BUTTON), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.constants.LOGIN_TEXT), 1),
                (_ctx.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.error), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("form", {
                  onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.jiraLogin && _ctx.jiraLogin(...args)), ["prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "username",
                      id: "usernameInput",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.jiraForm.username) = $event)),
                      placeholder: "Username"
                    }, null, 512), [
                      [_vModelText, _ctx.jiraForm.username]
                    ]),
                    (_ctx.errors.username && !_ctx.jiraForm.username)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.errors.username), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      type: _ctx.showPassword ? 'text' : 'password',
                      class: "userpassword",
                      id: "passwordInput",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.jiraForm.password) = $event)),
                      placeholder: "Password"
                    }, null, 8, _hoisted_16), [
                      [_vModelDynamic, _ctx.jiraForm.password]
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "password-toggle",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.togglePassword && _ctx.togglePassword(...args)))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(
                          _ctx.showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'
                        )
                      }, null, 2)
                    ]),
                    (_ctx.errors.password && !_ctx.jiraForm.password)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.errors.password), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _cache[5] || (_cache[5] = _createElementVNode("input", {
                          type: "checkbox",
                          name: "cbG11",
                          id: "rememberMeCheckbox",
                          class: "css-checkbox"
                        }, null, -1)),
                        _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.constants.REMEMBER_ME_LABEL), 1)
                      ]),
                      _createElementVNode("a", _hoisted_22, _toDisplayString(_ctx.constants.FORGOT_PASSWORD_LINK), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("button", {
                      class: "v1-button-outline",
                      type: "submit",
                      id: "loginButton",
                      disabled: _ctx.isLoading
                    }, _toDisplayString(_ctx.isLoading ? "Logging in..." : _ctx.constants.LOGIN_BUTTON), 9, _hoisted_24),
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "clear" }, null, -1))
                  ])
                ], 32)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ]))
}